import { Box } from '@mui/material';
import { useMemo } from 'react';
import { BikeleasingCalculator } from './BikeleasingCalculator';
import { BikeleasingContracts } from './BikeleasingContracts';
import { BikeleasingOverview } from './BikeleasingOverview';
import { BikeleasingRegister } from './BikeleasingRegister';
import { BikeleasingVendor } from './BikeleasingVendor';

export enum BikeleasingTabs {
  overview = 'OVERVIEW',
  calculator = 'CALCULATOR',
  vendorMap = 'VENDOR_MAP',
}
interface Props {
  tab?: BikeleasingTabs;
}

export const BikeleasingContent: React.FC<Props> = ({ tab }) => {
  const component = useMemo(() => {
    switch (tab) {
      case BikeleasingTabs.overview:
        return (
          <Box marginX={1} gap={1}>
            <BikeleasingRegister />
            <BikeleasingContracts />
            <BikeleasingOverview />
          </Box>
        );
      case BikeleasingTabs.calculator:
        return <BikeleasingCalculator />;

      case BikeleasingTabs.vendorMap:
        return <BikeleasingVendor tab={tab} />;

      default:
        break;
    }
  }, [tab]);

  return <>{component}</>;
};
